import { CloudflareImage } from '@components/primitives/Image/Cloudflare'
import { Text } from '@components/primitives/Text'
import { classMerge } from '@components/utilities/classMerge'

export function HipaaAndSoc2BadgeBox({ onClick }: { onClick?: () => void }) {
  return (
    <div
      className={classMerge(
        'flex w-full flex-col items-center gap-4 rounded-xl border border-neutral200 p-6',
        onClick ? 'cursor-pointer' : '',
      )}
      onClick={onClick}
    >
      <Text className='text-neutral500' styleName='p-strong'>
        Power Protects your data
      </Text>
      <div className='flex gap-6'>
        <CloudflareImage
          // 3159 × 4837 original size image
          alt='HIPAA compliant'
          className='h-[60px] w-[45px]'
          fit='contain'
          imageId='f1fde00f-aed0-429f-9d0b-eb3ab0a3bf00'
        />
        <CloudflareImage
          // 2488 × 936 original size image
          alt='SOC2 compliant'
          className='h-[60px] w-[150px]'
          fit='contain'
          imageId='329accfb-a641-4994-71cf-f787dc318800'
        />
      </div>
    </div>
  )
}
